import { useMemo } from 'react';
import { ADMIN_LINE_REQUESTS } from '@rsos/capstone/src/constants/capabilities';
import { ADMIN_LINE_REQUESTS_PERMISSION } from '@rsos/constants/permissions';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';

const useHasAccessToAdminLineRequests = () => {
  const hasAdminLinePermission = useHasPermission(
    ADMIN_LINE_REQUESTS_PERMISSION,
  );
  const hasAdminLineCapability = useHasCapability(ADMIN_LINE_REQUESTS);

  const hasAdminLineAccess = useMemo(() => {
    return (
      !!hasAdminLineCapability?.hasCapability &&
      !!hasAdminLinePermission?.hasPermission
    );
  }, [hasAdminLineCapability, hasAdminLinePermission]);

  return hasAdminLineAccess;
};

export default useHasAccessToAdminLineRequests;
